import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import SideBar from "../../SideBar";
import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import { FaCashRegister, FaRegTrashAlt, FaRegEdit } from "react-icons/fa";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";

import FileUploadHandler from "../../../../features/fileUploader";
import { api } from "../../../../api/api";
function SubCategory() {
  const [name, setName] = useState("");
  const [pointList, setPointList] = useState([]);
  const [point, setPoint] = useState("");
  const [type, setType] = useState("");
  const [amount, setAmount] = useState("");
  const [image, setImage] = useState(null);
  const [level, setLevel] = useState("");
  const [description, setDescription] = useState("");
  const [showUpdate, setShowUpdate] = useState(false);
  const [relatedDiscount, setRelatedDsicount] = useState([]);
  const [upCode, setUpCode] = useState("");
  const [upName, setUpName] = useState("");
  const [upDesc, setUpDesc] = useState("");
  const [discountList, setDiscountList] = useState([]);
  const [fixDiscountID, setFixDiscountID] = useState("");
  const [Id, setId] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setImage(e);
  };

  // const [categoryLists, setCategoryLists] = useState([]);
  const handleDelete = async (id) => {
    if (!id) {
      console.error("Invalid ID");
      return;
    }
    console.log("delete treatment with ID:", id);

    try {
      await api.delete(`tier-levels/${id}`);
      Swal.fire({
        title: "Deleted!",
        text: "The treatment has been deleted successfully.",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
      });
      console.log("success");

      setPointList((prev) => prev.filter((item) => item._id !== id));
    } catch (error) {
      console.error("Delete Error:", error);
      Swal.fire({
        title: "Error!",
        text: error.response?.data?.message || "Something went wrong.",
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  const handleUpdate = (event) => {
    // console.log(event, 'event')
    const getCatUpdate = async () => {
      try {
        const res = await api.get("tier/" + event);
        console.log(res.data.data, "event");
        setPoint(res.data.data.total_point);
        setName(res.data.data.name);
        setRelatedDsicount(res.data.data.relatedFixedDiscountPercent);

        setDescription(res.data.data.description);
      } catch (err) {}
    };
    getCatUpdate();
    setShowUpdate(true);
    setId(event);
  };

  const Update = () => {
    const data = {
      name: name,
      relatedFixedDiscountPercent: fixDiscountID
        ? fixDiscountID
        : relatedDiscount._id,
      total_point: point,
      description: description,
    };

    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .put("tier-level/" + Id, data, config)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "You Updated Data!",
          icon: "success",
          showConfirmButton: false,
          timer: 3000,
        });

        window.location.reload();
        //  setSubCategoryLists([...subCategoryLists, response.data.data]);
        // setPointList(
        //     pointList.map((category) => {
        //         if (category._id === response.data.data._id) {
        //             return response.data.data;
        //         } else {
        //             return category;
        //         }
        //     })
        // );
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
  };

  const HandleCreate = () => {
    if (!name || !point || !fixDiscountID || !level || !image || !description) {
      Swal.fire({
        title: "Missing Data!",
        text: "Please fill in all the fields.",
        icon: "warning",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("point", point);
    formData.append("relatedFixedDiscountPercent", fixDiscountID);
    formData.append("level", level);
    formData.append("imgUrl", image);
    formData.append("description", description);

    // alert(JSON.stringify(data));

    const config = {
      headers: { "Content-Type": "multipart/form-data/json" },
    };
    api
      .post("tier-levels/", formData, config)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "You Created Data!",
          icon: "success",
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();

        setPointList([...pointList, response.data.data]);
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          showCancelButton: false,
          timer: 3000,
        });
      });
  };
  useEffect(() => {
    const getSubCategory = async () => {
      try {
        const res = await api.get("tier-levels/membership");

        console.log(res.data.data, "sub cat");
        setPointList(res.data.data);
      } catch (err) {}
    };
    const getDiscount = async () => {
      try {
        const res = await api.get("v1/fix-discount-percent");

        console.log(res.data.data, "sub cat");
        setDiscountList(res.data.data);
      } catch (err) {}
    };

    getDiscount();
    getSubCategory();
  }, []);
  return (
    <>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <ol className="breadcrumb">
                <li className="breadcrumb-item active fs-5">Tier Level List</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Main content --> */}

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-9">
              <div className="card">
                <div className="card-header">
                  {/* <h3 className="card-title">Cost Center List</h3> */}
                </div>
                <div className="card-body">
                  <table id="example1" className="table">
                    <thead className=" bg-info">
                      <tr>
                        <th>No</th>
                        <th>Name</th>
                        <th>Point</th>
                        <th>Discount Name</th>
                        <th>Discount Percent</th>
                        <th>Level</th>
                        <th>Image</th>
                        <th>Description</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    {pointList.map((cat, i) => (
                      <tbody className="">
                        <tr>
                          <td>{++i}</td>
                          <td>{cat.name}</td>
                          <td>{cat.point}</td>
                          <td>{cat.level}</td>
                          <td>{cat.relatedFixedDiscountPercent?.name}</td>
                          <td>{cat.relatedFixedDiscountPercent?.percent}%</td>
                          <td>
                            <img
                              src={cat.imgUrl}
                              alt={cat.name}
                              style={{
                                width: "60px",
                                height: "60px",
                                objectFit: "cover",
                              }}
                            />
                          </td>
                          <td>{cat.description}</td>
                          <td className="text-center">
                            <div className="d-flex justify-content-center gap-2">
                              <button
                                className="btn btn-sm btn-warning"
                                onClick={(e) => handleUpdate(cat._id)}
                              >
                                <FaRegEdit />
                              </button>
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={(e) => handleDelete(cat._id)}
                              >
                                <FaRegTrashAlt />
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </div>
            </div>

            {showUpdate ? (
              <div className="col-md-3">
                <div className="card">
                  <h5 className="card-header mb-4 fw-5 text-secondary py-3">
                    Update Tier Level
                  </h5>
                  <div className="px-3 py-3">
                    <div class="form-group">
                      <label for="code" className="text-secondary">
                        Name
                      </label>
                      <input
                        type="text"
                        class="form-control border-info"
                        name="code"
                        id="code"
                        value={name}
                        //   ref={(el) => (this.name = el)}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>

                    <div class="form-group">
                      <label for="code" className="text-secondary">
                        Point
                      </label>
                      <input
                        type="number"
                        class="form-control border-info"
                        name="code"
                        id="code"
                        value={point}
                        //   ref={(el) => (this.name = el)}
                        onChange={(e) => setPoint(e.target.value)}
                      />
                    </div>
                    <div class="form-group">
                      <label for="name">Discount</label>
                      <select
                        class="custom-select border-info"
                        name="account_type_id"
                        id="cat"
                        onChange={(e) => setFixDiscountID(e.target.value)}
                      >
                        <option hidden>
                          {relatedDiscount.name} &nbsp; (
                          {relatedDiscount?.percent})
                        </option>

                        {discountList?.map((item, index) => (
                          <option key={item._id} value={item._id}>
                            {item.name}&nbsp; {`(${item.percent})`}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div class="form-group">
                      <label for="name" className="text-secondary">
                        Description
                      </label>
                      <textarea
                        className="form-control"
                        id="desc"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      ></textarea>
                    </div>
                    <button
                      style={{ backgroundColor: "#0b9490", color: "white" }}
                      className="btn  form-control text-center fw-5"
                      onClick={Update}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-md-3">
                <div className="card">
                  <h5 className="card-header mb-4 fw-5 text-secondary py-3">
                    Create Tier Level
                  </h5>
                  <div className="px-3 py-3">
                    <div class="form-group">
                      <label for="code" className="text-secondary">
                        Name
                      </label>
                      <input
                        type="text"
                        class="form-control border-info"
                        name="code"
                        id="code"
                        //   ref={(el) => (this.name = el)}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>

                    <div class="form-group">
                      <label for="code" className="text-secondary">
                        Point
                      </label>
                      <input
                        type="number"
                        class="form-control border-info"
                        name="code"
                        id="code"
                        //   ref={(el) => (this.name = el)}
                        onChange={(e) => setPoint(e.target.value)}
                      />
                    </div>
                    <div class="form-group">
                      <label for="level" className="text-secondary">
                        Level
                      </label>
                      <input
                        type="number"
                        class="form-control border-info"
                        name="level"
                        id="level"
                        onChange={(e) => setLevel(e.target.value)}
                      />
                    </div>

                    <div class="form-group">
                      <label for="name">Discount</label>
                      <select
                        class="custom-select border-info"
                        name="account_type_id"
                        id="cat"
                        onChange={(e) => setFixDiscountID(e.target.value)}
                      >
                        <option hidden>Choose Discount...</option>

                        {discountList?.map((item, index) => (
                          <option key={item._id} value={item._id}>
                            {item.name}&nbsp; {`(${item.percent} percent)`}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="py-2">
                      <label for="name">Main Image</label>
                      <FileUploadHandler handleChange={handleChange} />
                    </div>
                    <div class="form-group">
                      <label for="name" className="text-secondary">
                        Description
                      </label>
                      <textarea
                        className="form-control"
                        id="desc"
                        //   ref={(el) => (this.description = el)}
                        onChange={(e) => setDescription(e.target.value)}
                      ></textarea>
                    </div>
                    <button
                      style={{ backgroundColor: "#0b9490", color: "white" }}
                      className="btn  form-control text-center fw-5"
                      onClick={HandleCreate}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {/*<!-- /.container-fluid --> */}
      </section>
    </>
  );
}
export default SubCategory;
